/**
 * Access and preview copy: the «معاينة» bar over locked pages (DemoBanner),
 * the lock card (LockedCard) and the professional-only route guard
 * (ProfessionalRoute). Used through useTranslation('gating').
 */
const gating = {
  preview: 'Preview',
  checking: 'Checking access…',

  demo: {
    title: 'You are viewing a preview',
    body: 'This page shows real data for one example: {{district}} in {{city}}. To change the city, district or inputs:',
    bodyNoPlace: 'This page shows real data for one example. To change the city, district or inputs:',
    place: 'Example: {{district}}, {{city}}',
    regionLabel: '{{feature}} preview',
    signIn: 'Sign in',
    createAccount: 'Create an account',
    buyAddon: 'Buy the market intelligence add-on',
    subscribe: 'View plans',
    contactAdmin: 'Contact your company admin to activate the subscription',
    subscribersOnly: 'Market intelligence is available to broker and company plan subscribers',
    planNotIncluded: "Your current plan doesn't include market intelligence",
    example: 'Example',
  },

  pro: {
    title: 'For professional accounts',
    body: 'This page is available to brokers, companies, developers and real-estate professionals.',
    upgrade: 'Upgrade your account',
    register: 'Register as a professional',
    backHome: 'Back to home',
    checkFailed: "We couldn't verify your account type",
    checkFailedBody: 'Check your internet connection and try again.',
    retry: 'Try again',
  },
};

export default gating;
